;
(function(){
  if(window.__olUpsellInit) return; window.__olUpsellInit=true;
  var ADDON_IDS=[10309847449922,9882508558658,9882508656962,9952800899394];
  var cleaning=false, refreshing=false;
  function refreshDrawer(){
    refreshing=true;
    fetch('/?sections=cart-drawer').then(function(r){return r.json()}).then(function(d){
      var h=d['cart-drawer'];
      if(h){
        var doc=new DOMParser().parseFromString(h,'text/html');
        var nw=doc.getElementById('CartDrawer'), ol=document.getElementById('CartDrawer');
        if(nw&&ol) ol.innerHTML=nw.innerHTML;
      }
      fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
        var cd=document.querySelector('cart-drawer'); if(cd) cd.classList.toggle('is-empty', c.item_count===0);
        setTimeout(function(){refreshing=false;},80);
      });
    });
  }
  function cleanupOrphans(){
    if(cleaning||refreshing) return;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      if(!c.items.length) return;
      var hasMain=c.items.some(function(i){return ADDON_IDS.indexOf(i.product_id)<0;});
      if(hasMain) return;
      var ups={}, any=false;
      c.items.forEach(function(i){ if(ADDON_IDS.indexOf(i.product_id)>=0){ ups[i.variant_id]=0; any=true; } });
      if(!any) return;
      cleaning=true;
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:ups})})
        .then(function(){ cleaning=false; refreshDrawer(); });
    });
  }
  function olToggle(row){
    if(!row || row.getAttribute('data-busy')) return;
    var cb=row.querySelector('.ol-upsell-cb'); if(!cb) return;
    var vid=cb.getAttribute('data-variant-id'); if(!vid) return;
    var adding=!row.classList.contains('on');
    row.setAttribute('data-busy','1');
    row.classList.toggle('on',adding); cb.checked=adding;
    var url=adding?'/cart/add.js':'/cart/change.js';
    var body=adding?{id:vid,quantity:1}:{id:vid,quantity:0};
    fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
      .then(function(){refreshDrawer();})
      .catch(function(){row.classList.toggle('on',!adding);cb.checked=!adding;row.removeAttribute('data-busy');});
  }
  document.addEventListener('click', function(e){
    var row=e.target&&e.target.closest?e.target.closest('.ol-ups-row'):null;
    if(!row) return;
    e.preventDefault();
    olToggle(row);
  }, true);
  function attachObs(){
    var cd=document.getElementById('CartDrawer'); if(!cd) return;
    var obs=new MutationObserver(function(){ clearTimeout(window.__olCleanT); window.__olCleanT=setTimeout(cleanupOrphans,150); });
    obs.observe(cd,{childList:true,subtree:true});
    cleanupOrphans();
  }
  if(document.readyState!=='loading') attachObs(); else document.addEventListener('DOMContentLoaded', attachObs);
})();

;
(function(){
  "use strict";
  var SHOWN={"bliss-sticky-atc":"visible","olivia-sticky-atc":"visible","haven-sticky-atc":"visible"};
  function onScreen(el){
    if(!el)return false;
    var s=window.getComputedStyle(el);
    if(s.display==="none"||s.visibility==="hidden"||parseFloat(s.opacity||"1")<0.05)return false;
    var r=el.getBoundingClientRect();
    if(r.height<=0||r.width<=0)return false;
    var vh=window.innerHeight||document.documentElement.clientHeight;
    return r.top<vh && r.bottom>0;
  }
  function bars(){
    var list=[];
    Object.keys(SHOWN).forEach(function(id){var e=document.getElementById(id);if(e)list.push([e,SHOWN[id]]);});
    Array.prototype.forEach.call(document.querySelectorAll(".sticky-atc-bar,[data-ff-sticky-atc]"),function(e){list.push([e,"active"]);});
    return list;
  }
  function anyVisible(){
    var b=bars();
    for(var i=0;i<b.length;i++){
      var el=b[i][0],cls=b[i][1];
      // primary signal: the template's own "shown" class; fallback: actually on screen
      if((cls&&el.classList.contains(cls))||onScreen(el))return true;
    }
    return false;
  }
  var on=false;
  function recompute(){
    var v=anyVisible();
    if(v===on)return;
    on=v;
    document.body.classList.toggle("ff-sticky-atc-on",v);
  }
  var raf=null;
  function schedule(){ if(raf)return; raf=requestAnimationFrame(function(){raf=null;recompute();}); }
  function wire(){
    if(!document.body)return;
    recompute();
    window.addEventListener("scroll",schedule,{passive:true});
    window.addEventListener("resize",schedule,{passive:true});
    // class flips on the bars are how templates show/hide them -> observe them
    try{
      var mo=new MutationObserver(schedule);
      bars().forEach(function(b){mo.observe(b[0],{attributes:true,attributeFilter:["class","style"]});});
      // bars may be injected slightly after load; re-scan a few times early on
      var n=0,iv=setInterval(function(){
        bars().forEach(function(b){try{mo.observe(b[0],{attributes:true,attributeFilter:["class","style"]});}catch(e){}});
        schedule();
        if(++n>=6)clearInterval(iv);
      },500);
    }catch(e){}
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",wire);
  else wire();
})();

;
/* FF 2026-06-18: hide the Gorgias chat while a Klaviyo popup is open (owner: the
   "Need Help?" launcher was sitting in front of the welcome popup). Detects a
   visible, fixed/absolute, popup-sized Klaviyo element and toggles a body class
   that base.css uses to hide the chat. Conservative size gate avoids matching the
   inline embed form. */
(function(){
  if(window.__ffKlavWatch) return; window.__ffKlavWatch=1;
  var SEL='div[class*="klaviyo"],div[class*="kl-private"],form[class*="klaviyo"],[data-testid="POP_UP"],[aria-label*="POPUP" i]';
  function open(){
    var els=document.querySelectorAll(SEL);
    for(var i=0;i<els.length;i++){ var el=els[i]; var cs=getComputedStyle(el); if(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)<0.1) continue;
      if(cs.position!=='fixed'&&cs.position!=='absolute') continue; var r=el.getBoundingClientRect();
      if(r.width>=240&&r.height>=180&&r.bottom>0&&r.top<window.innerHeight) return true; }
    return false;
  }
  var last=null;
  function sync(){ var o=open(); if(o!==last){ last=o; document.body.classList.toggle('ff-klaviyo-open', o); } }
  if(document.readyState!=='loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  try{ new MutationObserver(sync).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class','aria-hidden']}); }catch(e){}
  setInterval(sync, 600);
})();
